import { investorsCopy } from "../content/investorsCopy";

// CEO/legal review required before this route is linked from nav/sitemap
// or allowed to index: patent language, named pilot, SAFE/take-rate/revenue.

export const INVESTOR_MAILTO_HREF =
  "mailto:raise@looporadata.ai?subject=" +
  encodeURIComponent("Investor deck request — LooporaData") +
  "&body=" +
  encodeURIComponent(
    [
      "Hi LooporaData team,",
      "",
      "I'd like to request the investor deck.",
      "",
      "My name:",
      "Fund / firm:",
      "Best way to reach me:",
      "",
      "What I'd like to learn more about:",
      "",
      "Thanks,",
      "",
    ].join("\n")
  );

export default function InvestorsPage() {
  const {
    hero,
    whyBuyersPay,
    marketExists,
    positioning,
    team,
    whereWeAre,
    returnProfile,
  } = investorsCopy;

  return (
    <main className="main" id="top">
      {/* HERO */}
      <section className="section section--with-glow hero" aria-label="Investors — overview">
        <div className="ambient-glow ambient-glow--hero-1" aria-hidden="true" />
        <div className="ambient-glow ambient-glow--hero-2" aria-hidden="true" />
        <div className="container">
          <h1 className="hero__headline">{hero.headline}</h1>
          {hero.paragraphs.map((paragraph) => (
            <p className="hero__tagline" key={paragraph}>
              {paragraph}
            </p>
          ))}
        </div>
      </section>

      {/* WHY BUYERS PAY */}
      <section className="section section--muted" id="demand" aria-labelledby="demand-heading">
        <div className="container">
          <p className="section__label">{whyBuyersPay.label}</p>
          <h2 className="section__headline" id="demand-heading">
            {whyBuyersPay.headline}
          </h2>
          <div className="cards cards--buyer">
            {whyBuyersPay.categories.map((category) => (
              <article className="card" key={category.title}>
                <h3 className="card__title">{category.title}</h3>
                <ul className="card__list">
                  {category.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* MARKET + POSITIONING */}
      <section className="section" id="market" aria-labelledby="market-heading">
        <div className="container">
          <p className="section__label">{marketExists.label}</p>
          <h2 className="section__headline" id="market-heading">
            {marketExists.headline}
          </h2>
          <div className="cards cards--2">
            <article className="card">
              <h3 className="card__title">{marketExists.scarcityTitle}</h3>
              <ul className="card__list">
                {marketExists.scarcity.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </article>
            <article className="card">
              <h3 className="card__title">{marketExists.demandTitle}</h3>
              <ul className="proofList">
                {marketExists.examples.map((example) => (
                  <li key={example.name}>
                    <span className="proofList__name">{example.name}</span>
                    <span className="proofList__signal">{example.signal}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>
          <aside className="positioning" aria-labelledby="positioning-heading">
            <p className="section__label">{positioning.label}</p>
            <h3 className="positioning__headline" id="positioning-heading">
              {positioning.headline}
            </h3>
            <p className="positioning__body">{positioning.question}</p>
            <p className="positioning__body">{positioning.answer}</p>
          </aside>
        </div>
      </section>

      {/* TEAM */}
      <section className="section section--muted" id="team">
        <div className="container">
          <p className="section__label">{team.label}</p>
          <div className="team__members">
            {team.members.map((member) => (
              <p className="section__intro" key={member.name}>
                <strong>
                  {member.role}{" "}
                  {member.linkedIn ? (
                    <a
                      className="link"
                      href={member.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {member.name}
                    </a>
                  ) : (
                    member.name
                  )}
                </strong>{" "}
                {member.bio}
              </p>
            ))}
          </div>
          <p className="section__intro team__tagline">
            <em>{team.tagline}</em>
          </p>
        </div>
      </section>

      {/* WHERE WE ARE */}
      <section className="section" id="where-we-are">
        <div className="container">
          <p className="section__label">{whereWeAre.label}</p>
          <ul className="marketFailure__list">
            {whereWeAre.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* RETURN PROFILE */}
      <section className="section section--muted" id="return-profile">
        <div className="container">
          <p className="section__label">{returnProfile.label}</p>
          <p className="section__intro">{returnProfile.sequenceIntro}</p>
          <p className="section__intro returnProfile__sequence">{returnProfile.sequence}</p>
          <p className="section__intro">{returnProfile.body}</p>
        </div>
      </section>
    </main>
  );
}
